import React, { useState, FunctionComponent, useEffect } from "react";

//styles
import styled from "styled-components";
import SV from "../../styles/variables";
import MQ from "../../styles/mediaQueries";

//models
import { Frame, FrameEnum } from "../../models/frame";

//components
import Filter from "../../components/filter";
import TableHeaderRowComponent from "./frameInfoTableHeader";

//mockdata
import { MockDataFrames } from "./helpers";

export interface IorderBy {
  type: FrameEnum;
  reversed: boolean;
}

const FrameInfoTable = () => {
  const [frames, setStateFrames] = useState(MockDataFrames);
  const [orderBy, setStateOrderBy] = useState<IorderBy>({
    type: "frameSKU",
    reversed: false
  });

  const filterItems = (
    colors: string[],
    brands: string[],
    lenses: string[],
    min: number,
    max: number
  ) => {
    let newFrames = [...MockDataFrames];
    if (colors.length > 0) {
      newFrames = newFrames.filter(frame => colors.includes(frame.color));
    }
    if (brands.length > 0) {
      newFrames = newFrames.filter(frame => brands.includes(frame.brand));
    }
    if (lenses.length > 0) {
      newFrames = newFrames.filter(frame => lenses.includes(frame.lensStyle));
    }
    newFrames = newFrames.filter(
      frame => frame.price >= min && frame.price <= max
    );
    OrderItems(orderBy, newFrames);
  };

  const clearFilters = () => {
    setStateFrames(MockDataFrames);
  };

  const OrderItems = ({ type, reversed }: IorderBy, frames: Frame[]): void => {
    let newFrames = [...frames];
    const key: keyof Frame = type;
    newFrames = newFrames.sort((a, b) => {
      if (
        key === "frameSKU" ||
        key === "brand" ||
        key === "lensStyle" ||
        key === "color"
      ) {
        return a[key].toLowerCase().localeCompare(b[key].toLowerCase());
      } else return a[key] - b[key];
    });
    if (reversed) {
      newFrames = newFrames.reverse();
    }
    setStateFrames(newFrames);
  };

  useEffect(() => {
    //first time component loads - order by frame SKU
    OrderItems(orderBy, frames);
  }, []);

  return (
    <Container>
      <HeaderRow>
        <h3> Detailed Frame Information </h3>
        <div style={{ position: "absolute", right: 10 }}>
          <Filter filterItems={filterItems} clearFilters={clearFilters} />
        </div>
      </HeaderRow>
      <Table>
        <div style={{ minWidth: 790 }}>
          <TableHeaderRowComponent
            setStateOrderBy={setStateOrderBy}
            orderItems={OrderItems}
            frames={frames}
          />

          <TBody>
            {frames.map(frame => (
              <TableRow key={frame.frameSKU}>
                <TD style={{ width: "152px" }}> {frame.frameSKU} </TD>
                <TD style={{ width: "104px" }}> {frame.price} </TD>
                <TD style={{ width: "150px" }}> {frame.brand} </TD>
                <TD style={{ width: "100px" }}> {frame.color} </TD>
                <TD style={{ width: "130px" }}> {frame.lensStyle} </TD>
                <TD style={{ width: "148px" }}> {frame.numberOfViews} </TD>
              </TableRow>
            ))}
          </TBody>
        </div>
      </Table>
    </Container>
  );
};

const Container = styled.div`
  display: flex column;
  background-color: white;
  width: 100%;

  padding: 16px 0;
  border-radius: 10px;
  box-shadow: 0 4px 20px 0 rgba(15, 40, 131, 0.08);
  font-size: 14px;
  ${MQ.laptop} {
    font-size: 16px;
  }
`;

const HeaderRow = styled.div`
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  margin: 0 16px;
  margin-bottom: 16px;
  height: 20px;
  h3 {
    font-size: 14px;
    line-height: 0;
    ${MQ.tablet} {
      font-size: 20px;
    }
  }
  ${MQ.tablet} {
    margin: 0 24px;
    margin-bottom: 16px;
  }
`;

const Table = styled.table`
  width: 100%;
  display: block;
  overflow-x: scroll;
`;

const TBody = styled.tbody`
  display: block;
  width: 100%;
  padding: 0 24px;
`;

const TableRow = styled.tr`
  display: flex;
  justify-content: space-between;
`;
const TD = styled.td`
  margin: 16px 0;
`;

export default FrameInfoTable;
